import React, {useState} from 'react';
import {PhoneHQConfirmDialog} from 'ch3-ui-lib';

interface DeleteMessageDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
    isDeleting?: boolean;
    label?: string;
}

export const DeleteMessageDialog: React.FC<DeleteMessageDialogProps> = ({
    open,
    onClose,
    onConfirm,
    isDeleting = false,
    label = 'Delete message for everyone',
}) => {
    const [error, setError] = useState<string | null>(null);

    const handleConfirm = async () => {
        setError(null);
        try {
            await onConfirm();
            onClose();
        } catch (e) {
            setError(e instanceof Error ? e.message : 'Failed to delete message');
        }
    };

    const handleClose = () => {
        setError(null);
        onClose();
    };

    return (
        <PhoneHQConfirmDialog
            open={open}
            onOpenChange={(isOpen) => { if (!isOpen) handleClose(); }}
            title={label + '?'}
            cancelLabel="Cancel"
            confirmLabel="Delete"
            tone="danger"
            busy={isDeleting}
            onConfirm={handleConfirm}
            footerNote={error && <p role="alert" className="m-0 mt-3 text-footnote text-danger-ink">{error}</p>}
        >
            This message will be permanently deleted for all participants.
        </PhoneHQConfirmDialog>
    );
};
